<script setup lang="ts">
withDefaults(
  defineProps<{
    title?: string
    size?: 'default' | 'small'
    bordered?: boolean
    hoverable?: boolean
    loading?: boolean
  }>(),
  {
    title: '',
    size: 'default',
    bordered: true,
    hoverable: false,
    loading: false
  }
)
</script>

<template>
  <section
    class="rr-card"
    :class="[
      `rr-card--${size}`,
      {
        'is-bordered': bordered,
        'is-hoverable': hoverable
      }
    ]"
  >
    <header v-if="title || $slots.title || $slots.extra" class="rr-card__header">
      <div class="rr-card__title">
        <slot name="title">{{ title }}</slot>
      </div>
      <div v-if="$slots.extra" class="rr-card__extra">
        <slot name="extra" />
      </div>
    </header>

    <div class="rr-card__body">
      <slot />
    </div>

    <footer v-if="$slots.footer" class="rr-card__footer">
      <slot name="footer" />
    </footer>
  </section>
</template>

<style scoped>
.rr-card {
  position: relative;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  background: var(--rr-color-surface);
  border-radius: var(--rr-radius-panel);
  color: var(--rr-color-text);
  font-size: 13px;
  transition: all 180ms ease;
}

.rr-card.is-bordered {
  border: 1px solid var(--rr-color-border);
  box-shadow: var(--rr-shadow-panel);
}

.rr-card.is-hoverable:hover {
  box-shadow: var(--rr-shadow-overlay);
  border-color: var(--rr-color-primary-border);
}

.rr-card__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 44px;
  padding: 10px 16px;
  border-bottom: 1px solid var(--rr-color-border);
}

.rr-card__title {
  font-size: 14px;
  font-weight: 700;
  color: var(--rr-color-text-strong);
}

.rr-card__extra {
  font-size: 12px;
  color: var(--rr-color-text-muted);
}

.rr-card__body {
  padding: 16px;
  flex: 1 1 auto;
}

.rr-card--small .rr-card__header {
  min-height: 36px;
  padding: 6px 12px;
}
.rr-card--small .rr-card__title {
  font-size: 13px;
}
.rr-card--small .rr-card__body {
  padding: 12px;
}

.rr-card__footer {
  padding: 10px 16px;
  border-top: 1px solid var(--rr-color-border);
  background: var(--rr-color-surface-subtle);
}
</style>
